import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { handleMktAnalytics } from '../../AmexUtils';
import { CTA_EVENT_NAME } from '../../constants';
import './LayoutDining.scss';

const LayoutDining = (
  {

    awsFolderName,
    baseRequestUrl,
    content: {
      images,
      title,
      copy,
      ctas,
    },
    tabHeading: heading,
    Analytics,
  }
) => {
  const urlPrefix = `${baseRequestUrl}${awsFolderName}/carouselImages/logos/`;
  const sanitizedHeading = sanitizeString(heading);
  const sanitizedTitle = sanitizeString(title);
  const sanitizedCopy = sanitizeString(copy);

  const handleClick = (cta) => {
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, {
      action_name: `${cta?.label} Click`,
      tab_item: heading,
    });
  };

  const displayCTA = (cta) => {
    const {
      label,
      name,
      url,
    } = cta;
    if (!label || !url) return null;
    switch (name) {
      case 'learnMore':
        return (
          <Link
            key={label}
            className="LayoutDining__cta primary"
            onClick={() => handleClick(cta)}
            href={url}
            target="_blank"
          >
            {label}
          </Link>
        );
      default:
        return (
          <Link
            key={label}
            className="LayoutDining__cta outline"
            onClick={() => handleClick(cta)}
            href={url}
            target="_blank"
          >
            {label}
          </Link>
        );
    }
  };

  return (
    <div className="LayoutDining">
      {heading && (
        <h3
          className="LayoutDining__heading content-heading"
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedHeading,
          }}
        />
      )}
      <div className="LayoutDining__inner">
        <div className="LayoutDining__content">
          <div className="LayoutDining__logos">
            {images && images.map((img) => (
              <div className="LayoutDining__logo" key={img}>
                <img src={`${urlPrefix}${img}`} alt="" />
              </div>
            ))}
          </div>
          <div className="LayoutDining__copy">
            {title && (
              <h3
                className="LayoutDining__title"
                dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                  __html: sanitizedTitle,
                }}
              />
            )}
            {copy && (
              <div
                dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                  __html: sanitizedCopy,
                }}
              />
            )}
          </div>
        </div>
        <div className="LayoutDining__footer">
          {ctas && ctas.map((cta) => displayCTA(cta))}
        </div>
      </div>
    </div>
  );
};

LayoutDining.propTypes = {
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    copy: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
    ctas: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  tabHeading: PropTypes.string,
};

LayoutDining.defaultProps = {
  tabHeading: '',
};

export default LayoutDining;
